<h1 class="title">Update Fund On Hold</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times" /></button>

<div class="details-page-edit-form">
  <form [formGroup]="updateForm">
    <rkt-form [form]="updateForm" [fields]="updateFields" [model]="formModel" />
  </form>

  @if (formError) {
    <div class="details-page-edit-form-error">{{ formError }}</div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button rktButton type="submit" (click)="onSubmit()" [disabled]="updateForm.invalid || isLoading" title="Update Fund On Hold">
      Update
    </button>
  </div>
</div>
